<template>
  <div>
    <div id="sorter">
        <h5>Programming</h5>
        <h5>Hardware</h5>
        <h5>Interior Design</h5>
        <h5>Product Design</h5>
    </div>
    <div id="projects">
      <div v-for="(item, index) in projects" :key="index">
        <Project :project="item" :id="index"/>      
      </div>
    </div>
  </div>
</template>

<style scoped>
  #projects {
    min-height: 100vh;
  }
  #sorter {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    box-shadow: 0px 3px 5px rgb(0,0,0,.4);
    position: sticky;
    padding: 10px;
    background-color: #444141;
  }
  #sorter h5 {
    margin: 5px;
    margin-left: 20px;
    margin-right: 20px;
    font-size: 1.3rem;
    padding: 5px;
    text-align: center;
    width: 12rem;
    transition: box-shadow 0.3s linear;
    border-radius: 5px;
    color: white;
  }
  #sorter h5:hover {
    cursor: default;
    color: #fbfaf9;
    box-shadow: inset 0px 0px 5px 1px rgba(0,0,0,0.57);
    background-color: #454e69;
    transition: background-color 0.3s linear;
  }
</style>

<script>
import Project from '@/components/Project.vue'
import ProjectData from '@/assets/data/projects.js'

export default {
  components: {
    Project
  },
  data() {
    return {
      projects: ProjectData.projects,
    }
  }
}
</script>